module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "value": _vm.show
    },
    on: {
      "update:value": function($event) {
        _vm.show = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Alteração em massa de Estoque")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h4', [_vm._v(_vm._s(this.products.length) + " produto(s) selecionado(s).")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12",
    class: {
      'has-danger': _vm.$v.quantidadeEstoque.$error
    }
  }, [_c('label', [_vm._v("Quantidade Estoque")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quantidadeEstoque),
      expression: "quantidadeEstoque"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.quantidadeEstoque)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.quantidadeEstoque = $event.target.value
      }, function($event) {
        _vm.$v.quantidadeEstoque.$touch()
      }]
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Fechar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("Alterar")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-138cd0c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalStock.vue
// module id = 829
// module chunks = 1